import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subject } from 'rxjs';
import { map, catchError, switchMap, take } from 'rxjs/operators';
import { ConfigState } from '@library/store/config/config.state'
import { ConfigFacade } from '@library/store/config/config.facade'
import { Const } from '@library/utils/constants/Const.constant'
import { CallbackService } from '@library/utils/services/callback.service'

@Injectable({
  providedIn: 'root'
})
export class HttpBuildingService {
  protected accessToken: string;
  protected badTokenCallback: void = null;
  config: ConfigState;
  private errors = new Subject<{ code: number } | boolean>();
  public errors$ = this.errors.asObservable();
  private trackedErrors = [
    400,
    404,
    405,
    500,
    501,
    0,
  ];

  constructor(
    protected http: HttpClient,
    protected callback: CallbackService,
    protected cookie: CookieService,
    protected configFacade: ConfigFacade) {
    }

  post(endpoint: string, params = {}, apiUrl?, options?: any): Observable<any> {

    return this.configFacade.config$.pipe(
      take(1),
      switchMap((config) => {
        const httpOptions = {
          headers: new HttpHeaders({
          'x-netatmo-token': this.cookie.get(config.cookiePrefix + 'access_token')
          }),
          ...options
        };

        return this.http.post(
          (apiUrl || config.apiUrl) + endpoint.toLowerCase(),
          params,
          httpOptions
        ).pipe(
          catchError((error) => {
            this.handleError(error);
            throw error;
          })
        );

      })
    );
  }

  get(endpoint: string, params = {}, apiUrl?: string): Observable<any> {

    return this.configFacade.config$.pipe(
      take(1),
      switchMap((config) => {
        const headers = new HttpHeaders({
          'x-netatmo-token': this.cookie.get(config.cookiePrefix + 'access_token')
        })
        return this.http.get(
          (apiUrl || config.apiUrl) + endpoint.toLowerCase(),
          {
            params,
            headers
          }
        ).pipe(
          map(response => (response as any).data),
          catchError( (error) => {
            this.handleError(error);
            throw error;
          })
        );
      }
    ));
  }

  put(endpoint: string, params = {}, apiUrl?, options?: any): Observable<any> {

    return this.configFacade.config$.pipe(
      take(1),
      switchMap((config) => {
        const httpOptions = {
          headers: new HttpHeaders({
          'x-netatmo-token': this.cookie.get(config.cookiePrefix + 'access_token')
          }),
          ...options
        };

        return this.http.put(
          (apiUrl || config.apiUrl) + endpoint.toLowerCase(),
          params,
          httpOptions
        ).pipe(
          catchError((error) => {
            this.handleError(error);
            throw error;
          })
        );

      })
    );
  }
  delete(endpoint: string, params = {}, apiUrl?, options?: any): Observable<any> {

    return this.configFacade.config$.pipe(
      take(1),
      switchMap((config) => {
        const httpOptions = {
          headers: new HttpHeaders({
          'x-netatmo-token': this.cookie.get(config.cookiePrefix + 'access_token')
          }),
          ...options
        };

        return this.http.delete(
          (apiUrl || config.apiUrl) + endpoint.toLowerCase(),
          httpOptions
        ).pipe(
          catchError((error) => {
            this.handleError(error);
            throw error;
          })
        );

      })
    );
  }
  handleError(err, preventGlobalError = false) {
    try {
      if (err.error.error !== undefined && err.error.error.code !== undefined) {

        switch (err.error.error.code) {

          case Const.NARestErrorCode.ACCESS_TOKEN_MISSING:
          case Const.NARestErrorCode.INVALID_ACCESS_TOKEN:
          case Const.NARestErrorCode.ACCESS_TOKEN_EXPIRED:
            this.callback.call('tokenExpired', undefined);
            break;
          default:
        }
      }

      if (this.trackedErrors.includes(err.status) && !preventGlobalError) {
          this.errors.next({ code: err.status });
      }

    } catch ($e) {
      console.log('ApiModuleNg2 Unknown error', err);
      throw new Error('Unknown error');
    }

    // TODO changer les erreurs pas les meme pour strapi

    console.error('ApiModuleNg2 error', err);
    throw err.error;
  }

  dismissError() {
    this.errors.next(false);
  }

}

